@if ((dataSource$ | async) === undefined || (dataSource$ | async) === null) {
  <div class="alert alert-info animated fadeIn" role="alert">
    Loading data...
  </div>
}

@if (fetching$ | async; as fetching) {
  <div class="terminal-events-content animated fadeIn">
    <div class="list-filter-block">
      <div>
        <ng-container *ngTemplateOutlet="bigScreenBlock"></ng-container>
      </div>
      <ng-template #bigScreenBlock class="animated fadeIn">
        <div class="row filterblock">
          <div class="col-12 col-sm-7 col-md-8">
            <div class="row">
              <div class="col-12 row">
                <date-filter
                  class="col-8"
                  (rangeChange)="setDateRange($event)"
                  [type]="dateFilter"
                  [showTime]="false"></date-filter>
                @if (listConfig.filterBlockConfig.textFilter) {
                  <div class="col-4 d-flex align-items-center">
                    <div class="row text-filter-holder">
                      <div class="d-flex w-75 p-0">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Search..."
                          (keyup.enter)="filterText()"
                          [(ngModel)]="textFilter" />
                      </div>
                      <div class="d=flex w-25">
                        <button
                          type="button"
                          class="btn btn-primary"
                          (click)="filterText()"
                          (keydown.enter)="filterText()">
                          <i class="fa fa-search"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
            <div class="row">
              @if (listConfig.filterBlockConfig.eventsFilter) {
                <div class="col-auto flex-fill">
                  <app-terminal-events-filter
                    [filters]="selectedSourceNames$"
                    (itemChanged)="onFilterChanged($event)"
                    (onSelectAll)="selectAllFilters($event)">
                  </app-terminal-events-filter>
                </div>
              }
            </div>
            @if (listConfig.filterBlockConfig.dynamicFilter) {
              <div class="container">
                <app-dynamic-filters
                  [dynamicFilters$]="dynamicFilters$"
                  (removeDynamicFilter)="
                    removeDynamicFilter($event)
                  "></app-dynamic-filters>
              </div>
            }
          </div>
          <div class="col-12 col-sm-5 col-md-4">
            <div class="row bs-flex-row">
              @if (
                listConfig.enableLastBoot &&
                listConfig.filterBlockConfig.lastBootLink
              ) {
                <button
                  type="button"
                  class="btn btn-link float-right"
                  (click)="jumpToLastBoot()"
                  (keydown.enter)="jumpToLastBoot()">
                  Last BOOT
                </button>
              }
              <button
                class="btn btn-primary"
                (click)="exportData()"
                (keydown.enter)="exportData()">
                Export
              </button>
              @if (
                listConfig.listType !== ListType.ADVANCED &&
                listConfig.filterBlockConfig.resetButton
              ) {
                <button
                  type="button"
                  class="btn btn-link float-right"
                  (click)="resetView()"
                  (keydown.enter)="resetView()">
                  <i class="fa fa-repeat"></i>&nbsp;Reset view
                </button>
              }
              @if (listConfig.filterBlockConfig.resetButton) {
                <button
                  type="button"
                  class="btn btn-link float-right"
                  (click)="clearAllFilters()"
                  (keydown.enter)="clearAllFilters()">
                  <i class="fa fa-undo"></i>&nbsp;Reset filters
                </button>
              }
            </div>
            @if (listConfig.filterBlockConfig.dateJumper) {
              <div class="row">
                <app-terminal-events-date-jumper
                  (changed)="
                    jumpToDatetime($event)
                  "></app-terminal-events-date-jumper>
              </div>
            }
          </div>
        </div>
      </ng-template>
    </div>
    @if (
      fetching.fetching && fetching.direction === LoadDirection.TIME_FORWARD
    ) {
      <div class="fetching"><div class="fetching-up">loading...</div></div>
    }
    @if ((hasData$ | async) === false || (dataSource$ | async)?.length === 0) {
      <div class="alert alert-light animated fadeIn" role="alert">
        {{ notDataText }}
      </div>
    }
    @if (listConfig.listType === ListType.ADVANCED) {
      <div
        class="virtualscrollHolder"
        (resized)="onResized($event)"
        copyFormatExcel>
        <div
          class="detail-anchor"
          [ngClass]="{
            bigdetail: detailBig,
            smalldetail: !detailBig,
            emptydetail:
              (selectedRowData$ | async) === null ||
              (selectedRowData$ | async) === undefined,
          }">
          @if (
            (selectedRowData$ | async) &&
            (isSmallScreen$ | async)?.matches === false
          ) {
            <app-terminal-events-detail
              class="toBottom"
              [data$]="selectedRowData$"
              [configurationFileName]="listConfig.fieldDefinitions.detail"
              [eventName]="listConfig.convenienceFilter"
              (detailAttributeChanged)="dynamicFilterChanged($event)"
              (detailSizeChanged)="setDetailViewSize($event)"
              [selectedFilters$]="dynamicFilters$"
              (jump)="jumpTo($event)"
              (reset)="resetView()"
              [isBig]="detailBig"
              [style.height]="detailHeight"></app-terminal-events-detail>
          }
        </div>
        <app-infinite-scroll-list
          [data$]="data$"
          [listItemTemplateRef]="listItemTemplateRef"
          (onScrollEnd)="handleScrollEnd($event)"
          [config]="{
            rowIdentifier: 'ingestSequence',
            striped: true,
            minWidth: '1600px',
          }">
        </app-infinite-scroll-list>
        <ng-template #listItemTemplateRef let-item="item" let-index="index">
          <li
            (click)="selectRow(item, detailViewModal)"
            (keydown.enter)="selectRow(item, detailViewModal)"
            [id]="'row-' + item.ingestSequence"
            class="list-group-item scroll-list-item">
            <div class="row">
              <div class="col src-name-col">
                <div class="event-list-control-field">
                  {{ item.sourceName }}
                  @if (item.active) {
                    <span class="float-right">
                      <app-terminal-events-jumper
                        (clicked)="jumpTo($event)"
                        [config]="{
                          showAnyJumper: false,
                          showBootJumper: false,
                          extraSmall: true,
                          showLabels: false,
                        }">
                      </app-terminal-events-jumper>
                    </span>
                  }
                </div>
              </div>
              <div class="col-auto col-date">
                <span>
                  <multi-tz-date
                    [date]="item.timestamp"
                    [terminalTz]="item[listConfig.timezoneField]"
                    placement="right">
                  </multi-tz-date>
                </span>
              </div>
              <div class="col-dynamic d-flex align-items-start">
                <div class="container">
                  <div class="row">
                    @for (
                      dynamicColumn of item.dynamicColumns;
                      track dynamicColumn
                    ) {
                      <div
                        [attr.colspan]="dynamicColumn.colspan"
                        [ngClass]="dynamicColumn.classes"
                        class="col-auto">
                        {{ dynamicColumn.value }}
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ng-template>
      </div>
    }
    @if (listConfig.listType === ListType.SIMPLE_DETAIL) {
      <div
        class="virtualscrollHolder"
        (resized)="onResized($event)"
        copyFormatExcel>
        <app-infinite-scroll-list
          [data$]="data$"
          [listItemTemplateRef]="simpleDetailListItemTemplateRef"
          [config]="{}"
          (onScrollEnd)="handleScrollEnd($event)">
        </app-infinite-scroll-list>
        <ng-template #simpleDetailListItemTemplateRef let-item="item">
          <li
            class="list-group-item scroll-list-item"
            [ngClass]="{odd: item.scrollIndex % 2 == 0}"
            (click)="
              item.showDetailsInline = item.showDetailsInline
                ? !item.showDetailsInline
                : true
            "
            (keydown.enter)="
              item.showDetailsInline = item.showDetailsInline
                ? !item.showDetailsInline
                : true
            ">
            <div class="row">
              @for (dynamicColumn of item.dynamicColumns; track dynamicColumn) {
                <div
                  class="col"
                  [attr.colspan]="dynamicColumn.colspan"
                  [ngClass]="dynamicColumn.classes">
                  @if (dynamicColumn.type === 'Timestamp') {
                    <span>
                      <multi-tz-date
                        [date]="dynamicColumn.value"
                        [terminalTz]="item[listConfig.timezoneField]"
                        placement="right">
                      </multi-tz-date>
                    </span>
                  } @else {
                    {{ dynamicColumn.value }}
                  }
                </div>
              }
            </div>
          </li>
          @if (item.showDetailsInline) {
            <li
              class="list-group-item list-group-item-secondary inline-detail-box">
              <div class="detailrow">
                @for (detail of item.detailData; track detail) {
                  <div class="col">
                    {{ detail.detailValue.length ? detail.detailValue : '-' }}
                  </div>
                }
              </div>
            </li>
          }
        </ng-template>
        <!-- <cdk-virtual-scroll-viewport id="virtualScrollContainer" class="list-container list-group v-list toBottom"
          [itemSize]="30" [maxBufferPx]="1000" [minBufferPx]="1000" id="virtualScrollContainer">
          <ul class="list-group">
            <span  *cdkVirtualFor="let item of data$ | async; templateCacheSize: 0; let i = index; let data;"
              [ngClass]="{'table-warning': item.active}"
              [id]="'row-' + item.ingestSequence">
              <li class="list-group-item scroll-list-item" (click)="item.showDetailsInline = item.showDetailsInline ? !item.showDetailsInline : true" (keydown.enter)="item.showDetailsInline = item.showDetailsInline ? !item.showDetailsInline : true">
                <div class="row">
                  <div class="col" *ngFor="let dynamicColumn of item.dynamicColumns" [attr.colspan]="dynamicColumn.colspan"
                    [ngClass]="dynamicColumn.classes">
                    <span *ngIf="dynamicColumn.type === 'Timestamp';else plain_text_content">
                      <multi-tz-date [date]="dynamicColumn.value" [terminalTz]="item[listConfig.timezoneField]" placement="right">
                      </multi-tz-date>
                    </span>
                    <ng-template #plain_text_content>
                      {{dynamicColumn.value}}
                    </ng-template>
                  </div>
                </div>
              </li>
              <li  *ngIf="item.showDetailsInline" class="list-group-item list-group-item-secondary inline-detail-box" [@enterAnimation]>
                <div class="row">
                  <div class="col" *ngFor="let detail of item.detailData">
                    {{detail.detailValue.length ? detail.detailValue : '-'}}
                  </div>
                </div>
              </li>
            </span>
          </ul>
        </cdk-virtual-scroll-viewport> -->
      </div>
    }
    @if (
      fetching.fetching && fetching.direction === LoadDirection.TIME_BACKWARD
    ) {
      <div class="fetching"><div class="fetching-down">loading...</div></div>
    }
  </div>
}
<ng-template #detailViewModal let-modal>
  <div class="modal-header">
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
      (keydown.enter)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <app-terminal-event-detail-toggler
      [data$]="selectedRowData$"
      [configurationFileName]="listConfig.fieldDefinitions.detail"
      [eventName]="listConfig.convenienceFilter"
      (detailAttributeChanged)="dynamicFilterChanged($event)"
      [selectedFilters$]="dynamicFilters$"
      (jump)="jumpTo($event)"
      (reset)="resetView()">
    </app-terminal-event-detail-toggler>
  </div>
</ng-template>
